var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/zone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12304 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.5892C0 11.0369 0.447715 10.5892 1 10.5892H5V12.5892H2V15.5892H0V11.5892ZM12 12.5892H9V10.5892H13C13.5523 10.5892 14 11.0369 14 11.5892V15.5892H12V12.5892ZM2 22.5892V19.5892H0V23.5892C0 24.1415 0.447715 24.5892 1 24.5892H5V22.5892H2ZM12 22.5892V19.5892H14V23.5892C14 24.1415 13.5523 24.5892 13 24.5892H9V22.5892H12Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12305 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.58923C10 1.03695 10.4477 0.589233 11 0.589233H15V2.58923H12V5.58923H10V1.58923ZM22 2.58923H19V0.589233H23C23.5523 0.589233 24 1.03695 24 1.58923V5.58923H22V2.58923ZM22 12.5892V9.58923H24V13.5892C24 14.1415 23.5523 14.5892 23 14.5892H19V12.5892H22Z",
    fill: "inherit"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/Layout.7a40fffc5a1a823fb766686b05710f87.svg";
export { ForwardRef as ReactComponent };